/**
 * @prop --ratio: Ratio (e.g. 16 / 9)
 * @prop --background-color: Background color of ratio area
 * @prop --max-height: Max height of the ratio, useful when viewport is huge
 * @prop --overflow: In combination with max height you might wanna hide overflow
 *
 * @prop --stzh-ratio-background-color: **Global**: Background color of ratios
 */

:host {
  --background-color: #{$ratioBackgroundColor};
  --ratio: #{nth(map-get($ratios, $ratioDefault), 1)}
    / #{nth(map-get($ratios, $ratioDefault), 2)};
  --max-height: inherit;
  --overflow: inherit;

  ::slotted(*) {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: cover;
  }

  ::slotted(.stzh-card-searchresult__image-placeholder) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: var(--placeholder-image-color);
  }
}

:host([fit="contain"]) ::slotted(*) {
  object-fit: contain;
}

/* Ratio variants */

:host([portrait]:not([portrait="false"])) {
  --ratio: #{nth(map-get($ratios, $ratioDefault), 2)}
    / #{nth(map-get($ratios, $ratioDefault), 1)};
}

@mixin ratioProps($breakpoint: null) {
  @each $ratio, $value in $ratios {
    $firstNr: nth($value, 1);
    $secondNr: nth($value, 2);

    @if $breakpoint {
      :host([ratio-#{$breakpoint}="#{$ratio}"]) {
        @include mq($from: $breakpoint) {
          --ratio: #{$firstNr} / #{$secondNr};
        }
      }

      :host([ratio-#{$breakpoint}="#{$ratio}"][portrait]:not([portrait="false"])) {
        @include mq($from: $breakpoint) {
          --ratio: #{$secondNr} / #{$firstNr};
        }
      }
    } @else {
      :host([ratio="#{$ratio}"]) {
        --ratio: #{$firstNr} / #{$secondNr};
      }

      :host([ratio="#{$ratio}"][portrait]:not([portrait="false"])) {
        --ratio: #{$secondNr} / #{$firstNr};
      }
    }
  }
}

@include ratioProps();

@each $breakpoint, $size in $breakpoints {
  @include ratioProps($breakpoint);
}

.stzh-ratio {
  position: relative;
  width: 100%;
  aspect-ratio: var(--ratio);
  background: var(--background-color);
  max-height: var(--max-height);
  overflow: var(--overflow);
}
